import './App.css';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Header from './components/Header';
import Footer from './components/Footer';
import SummaryApi from './common';
import Context from './context';
import { setUserDetails } from './store/userSlice';

function App() {
  const dispatch = useDispatch();
  const [cartProductCount, setCartProductCount] = useState(0);

  const fetchUserDetails = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      let url = SummaryApi.current_user.url;

      if (token) {
        url += `?token=${token}`;
      }

      const response = await fetch(url, {
        method: SummaryApi.current_user.method,
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        }
      });

      const dataApi = await response.json();

      if (dataApi.success) {
        dispatch(setUserDetails(dataApi.data));
      } else if (dataApi.message === "Invalid or Expired Token") {
        console.warn("Token expired, logging out...");
        localStorage.removeItem("token");
        dispatch(setUserDetails(null));
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
      dispatch(setUserDetails(null));
    }
  }, [dispatch]);

  const fetchUserAddToCart = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      let url = SummaryApi.addToCartProductCount.url;

      if (token) {
        url += `?token=${token}`;
      }

      const dataResponse = await fetch(url, {
        method: SummaryApi.addToCartProductCount.method,
        credentials: 'include'
      });

      const dataApi = await dataResponse.json();
      setCartProductCount(dataApi?.data?.count || 0);
    } catch (error) {
      console.error("Error fetching cart count:", error);
      setCartProductCount(0);
    }
  }, []);

  useEffect(() => {
    fetchUserDetails();
    fetchUserAddToCart();
  }, [fetchUserDetails, fetchUserAddToCart]);

  return (
    <>
      <Context.Provider value={{
        fetchUserDetails,
        cartProductCount,
        fetchUserAddToCart
      }}>
        <ToastContainer position='top-center' />

        <Header />
       < div className='mt-3'/>
        <main className='min-h-[calc(100vh-120px)] pt-36'>
          <Outlet />
        </main>
        <Footer />
      </Context.Provider>
    </>
  );
}

export default App;